export default {
  // urlPrefix: 'http://zhiyihealth.com.cn:8080/applyInfo/',
  // urlPrefix: 'http://gwboss.zhiyihealth.com.cn/zhiyiHealth/applyInfo/',
  urlPrefix: 'http://www.zhiyihealth.com.cn/zhiyiHealth/applyInfo',
  getVerificationCode: '/getVerificationCode?detail=', // 获取手机验证码
  commitApplyInfo: '/commitApplyInfo?detail=' // 提交申请
}
